import "../../../src/App.css";
import "../../pages/PettyCashHistorylist/PettyCashHistorylist.css";
import PettyCashHistory from "../../components/PettyCashHistory/PettyCashHistory";
import React, { useState } from "react";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ReimbursedIcon from "../../Icons/Reimbursed.png";
import PettyCashIcon from "../../Icons/PettyCash.png";
import BalanceIcon from "../../Icons/Balance.png";


function PettyCashHistorylist() {
  // const [openProfile, setOpenProfile] = useState(false);

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />

        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4", width: "100%", overflowX: "auto" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "1%",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Petty Cash List | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Accounts & Finance</span>
                  <span style={{ fontSize: "20px", paddingLeft: "10px" }}>&gt; Petty Cash</span>
                  <span style={{ fontSize: "20px", paddingLeft: "10px" }}>&gt; Petty Cash List</span>
                </h1>
              </div>

            </div>
            <div>

              <Wrapper className="LeadDetails px-0 pettycashHistory-bgcolor" style={{ border: "1px solid #5B489D", background: "#F0EBFF" }}>
                <div className="row">
                  <div
                    style={{ borderRight: "2px solid #000000" }}
                    className="col-4 px-0"
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <img className="img-fluid" src={ReimbursedIcon} />
                      <div className="px-4">
                        <h6 style={{ fontWeight: "bold", color: "black" }}>
                          Total Reimbursed
                        </h6>
                        <h5 style={{ color: "#5B489D", fontWeight: "bold" }}>
                          ₹ 1,367
                        </h5>
                        <h6>
                          Last Month:{" "}
                          <span style={{ color: "#5B489D", fontWeight: "bold" }}>
                            ₹ 1,560
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{ borderRight: "2px solid #000000" }}
                    className="col-4 px-0"
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <img className="img-fluid" src={PettyCashIcon} />
                      <div className="px-4">
                        <h6 style={{ fontWeight: "bold", color: "black" }}>
                          Total Petty Cash
                        </h6>
                        <h5 style={{ color: "#5B489D", fontWeight: "bold" }}>
                          ₹ 1,367
                        </h5>
                        <h6>
                          Last Month:{" "}
                          <span style={{ color: "#5B489D", fontWeight: "bold" }}>
                            ₹ 1,560
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-4 px-0">
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <img className="img-fluid" src={BalanceIcon} />
                      <div className="px-4">
                        <h6 style={{ fontWeight: "bold", color: "black" }}>
                          Overall Balance
                        </h6>
                        <h5 style={{ color: "#5B489D", fontWeight: "bold" }}>
                          ₹ 1,367
                        </h5>
                        <h6>
                          Last Month:{" "}
                          <span style={{ color: "#5B489D", fontWeight: "bold" }}>
                            ₹ 1,560
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </Wrapper>
              <br></br>
              <Wrapper className="ViewLeadDetails wrapperLeadDataReport" >
                <PettyCashHistory />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PettyCashHistorylist;
